import { defaultHttpClient } from '../../httpClient';
import type {
  PostVerificationValidateRequest,
  PostVerificationValidateResponse,
} from './types';

/**
 * SMS 인증번호 검증. 응답 registered_member가 있으면 이미 가입된 번호(점유).
 * iOS/Android 네이티브와 동일한 /verification/validate/ 엔드포인트(trailing slash 포함).
 */
export const postVerificationValidate = (
  params: PostVerificationValidateRequest,
) => {
  return defaultHttpClient
    .request<PostVerificationValidateResponse>({
      method: 'POST',
      url: '/api/v2/verification/validate/',
      data: params,
    })
    .then(result => result.data);
};
